import React from "react";

import { useIntl } from "react-intl";

import { Button } from "@mapmycustomers/ui";

import styles from "./NoResults.module.scss";

interface Props {
  onClear?: () => void;
  onShowTimelinePreferences?: () => void;
}

const NoResults: React.FC<Props> = ({ onClear, onShowTimelinePreferences }) => {
  const intl = useIntl();
  return (
    <div className={styles.container}>
      <div className={styles.title}>
        {intl.formatMessage({
          id: "dashboard.timeline.noResults",
          defaultMessage: "No results",
          description: "No results message in Dashboard Timeline",
        })}
      </div>
      <div className={styles.description}>
        {intl.formatMessage({
          id: "dashboard.timeline.noResults.description",
          defaultMessage:
            "There might not be any recorded activity for this action type or search result, or some results could be hidden according to your preferences.",
          description: "No results description in Dashboard Timeline",
        })}
      </div>
      <div className={styles.buttons}>
        <Button onClick={onClear} type="filled">
          {intl.formatMessage({
            id: "dashboard.timeline.noResults.clearFilters",
            defaultMessage: "Clear filters",
            description: "Clear filters button when there are no events in Dashboard Timeline",
          })}
        </Button>
        <Button onClick={onShowTimelinePreferences}>
          {intl.formatMessage({
            id: "dashboard.timeline.noResults.timelinePreferences",
            defaultMessage: "Timeline Preferences",
            description:
              "Show timeline preferences button when there are no events in Dashboard Timeline",
          })}
        </Button>
      </div>
    </div>
  );
};

export default NoResults;
